(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8487],{

/***/ 58115:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vendors",
      function () {
        return __webpack_require__(79942);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 40243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var algoliasearch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64434);
/* harmony import */ var algoliasearch__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(algoliasearch__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = (algoliasearch__WEBPACK_IMPORTED_MODULE_0___default()("EKEGGUH63H", "MTYxNmZmYzhhMTFkNjI2NjcwZDFhZTM0ZmRmYjliY2U2MTQ3ZGJjMDgxY2M4YWE1ODA0YTJjZDQ5OTkyZmUwM3ZhbGlkVW50aWw9NDcyOTQyNjk1NQ=="));


/***/ }),

/***/ 31617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getIndexName; }
/* harmony export */ });
function getIndexName(index) {
    return "".concat(index, "_").concat("production");
};


/***/ }),

/***/ 79942:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ vendors; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(29452);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(45597);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./components/search/utils/algoliaClient.ts
var algoliaClient = __webpack_require__(40243);
// EXTERNAL MODULE: ./components/search/utils/getIndexName.ts
var getIndexName = __webpack_require__(31617);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18316);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+web@2.32.25_cmry25ein5ld6qeazx5fxbvqjy/node_modules/@govlaunch/web/index.ts + 112 modules
var web = __webpack_require__(19026);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/link.js
var next_link = __webpack_require__(54892);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-use@17.4.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-use/esm/useDebounce.js + 1 modules
var useDebounce = __webpack_require__(38594);
// EXTERNAL MODULE: ./src/components/navbar/NavbarLayout.tsx + 62 modules
var NavbarLayout = __webpack_require__(71858);
// EXTERNAL MODULE: ./src/components/home/HomepageNavigation.tsx
var HomepageNavigation = __webpack_require__(72851);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(69057);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(90489);
// EXTERNAL MODULE: ./lib/hooks/useIsMobile.ts
var useIsMobile = __webpack_require__(67459);
;// CONCATENATED MODULE: ./src/components/translation/TranslationLinkButton.tsx





var TranslationLinkButton = /*#__PURE__*/ react.forwardRef(function(param, ref) {
    var onClick = param.onClick, href = param.href, paddingY = param.paddingY;
    var isMobile = (0,useIsMobile/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Anchor */.ee, {
        href: href,
        onClick: onClick,
        ref: ref,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
            color: isMobile ? "gray.900" : "blue.600",
            fontSize: isMobile ? "12px" : "14px",
            border: isMobile ? "1px solid #ADB6C3" : "",
            borderRadius: "4px",
            py: paddingY ? paddingY : "4px",
            px: "10px",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                defaultMessage: "see translation",
                id: "jJqiqa"
            })
        })
    });
});
/* harmony default export */ var translation_TranslationLinkButton = (TranslationLinkButton);

// EXTERNAL MODULE: ./lib/withIntl.tsx + 9 modules
var withIntl = __webpack_require__(21505);
// EXTERNAL MODULE: ./components/seo/SeoHead.tsx
var SeoHead = __webpack_require__(35692);
;// CONCATENATED MODULE: ./components/seo/VendorsPageSeo.tsx




function VendorsPageSeo() {
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SeoHead/* default */.Z, {
        title: intl.formatMessage({
            defaultMessage: "Local Government Innovation Vendors",
            id: "wVOwCh"
        }),
        description: intl.formatMessage({
            defaultMessage: "Search local government technology vendors on Govlaunch.",
            id: "vaL9LZ"
        })
    });
};

;// CONCATENATED MODULE: ./src/components/home/pages/VendorsPage.tsx













var VendorsPage = function(param) {
    var initialResults = param.initialResults;
    var concatMoreVendors = function concatMoreVendors(nextVendors) {
        return setVendors(function(currentVendors) {
            return currentVendors.concat(nextVendors);
        });
    };
    var ref = (0,react.useState)(initialResults.hits), vendors = ref[0], setVendors = ref[1];
    var locale = (0,withIntl/* useIntlLocale */.U)().locale;
    var ref1 = (0,web/* useAlgoliaSearch */.xY)({
        initialResults: initialResults,
        initialSearchState: {
            index: "companies",
            hitsPerPage: 15
        },
        onResults: function(param) {
            var results = param.results;
            if (results.page > 0) {
                concatMoreVendors(results.hits);
                return;
            }
            setVendors(results.hits);
        }
    }), results = ref1.results, loading = ref1.loading, setSearchState = ref1.setSearchState, searchState = ref1.searchState;
    var ref2 = (0,react.useState)(""), inputValue = ref2[0], setInputValue = ref2[1];
    (0,useDebounce/* default */.Z)(function() {
        setSearchState(function(currentState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, currentState), {
                page: 0,
                query: inputValue
            });
        });
    }, 300, [
        inputValue
    ]);
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NavbarLayout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VendorsPageSeo, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HomepageNavigation/* default */.Z, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* PageGridContainer */.pf, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                        bg: [
                            "none",
                            "none",
                            "blue.100"
                        ],
                        px: [
                            0,
                            0,
                            10
                        ],
                        py: 3,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Input */.II, {
                            "aria-label": "Search for vendors",
                            placeholder: intl.formatMessage({
                                defaultMessage: "Search for vendors...",
                                id: "wc+cGC"
                            }),
                            value: inputValue,
                            onChange: function(e) {
                                return setInputValue(e.target.value);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* SimpleGrid */.MI, {
                        columns: [
                            1,
                            1,
                            2,
                            3
                        ],
                        spacing: 6,
                        mt: 6,
                        children: vendors.map(function(vendor) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Flex */.kC, {
                                borderRadius: "md",
                                border: "1px",
                                borderColor: "gray.100",
                                bg: "white",
                                direction: "column",
                                children: [
                                    locale !== "en-US" && (typeof vendor.usersCanRequestContentTranslation === "undefined" || vendor.usersCanRequestContentTranslation === null || vendor.usersCanRequestContentTranslation) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        css: {
                                            alignSelf: "flex-end",
                                            marginTop: "3px",
                                            marginRight: "3px",
                                            marginBottom: "-10px"
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                            href: "/vendors/".concat(vendor.slug, "/").concat(locale),
                                            as: "/vendors/".concat(vendor.slug, "?lang=").concat(locale),
                                            passHref: true,
                                            scroll: false,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(translation_TranslationLinkButton, {
                                                paddingY: 1
                                            })
                                        }, vendor._id)
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                        href: "/vendor?vendorSlug=".concat(vendor.slug),
                                        as: "/vendors/".concat(vendor.slug),
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                                            as: "a",
                                            display: "flex",
                                            alignItems: "center",
                                            p: 4,
                                            overflow: "hidden",
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Avatar */.qE, {
                                                    src: vendor.logo,
                                                    name: vendor.name,
                                                    size: "xl",
                                                    mr: 6
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                                            color: "blue.600",
                                                            fontSize: "lg",
                                                            fontWeight: "semibold",
                                                            mb: 2,
                                                            clamp: 2,
                                                            children: vendor.name
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                                            color: "gray.900",
                                                            fontSize: "md",
                                                            clamp: 4,
                                                            children: vendor.description
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }, vendor.slug);
                        })
                    }),
                    (searchState.page || 0) + 1 < ((results === null || results === void 0 ? void 0 : results.nbPages) || 0) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                        display: "flex",
                        justifyContent: "center",
                        py: 6,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Button */.zx, {
                            variant: "secondary",
                            loading: loading,
                            size: "sm",
                            rightIcon: function(props) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    width: "24",
                                    height: "12",
                                    viewBox: "0 0 24 12",
                                    fill: "none"
                                }, props), {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M2 2.5L11.7436 9.55882L22 2.5",
                                        stroke: "currentColor",
                                        strokeWidth: "3",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                }));
                            },
                            onClick: function() {
                                setSearchState(function(currentState) {
                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, currentState), {
                                        page: (currentState.page || 0) + 1
                                    });
                                });
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Show more",
                                id: "aWpBzj"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var pages_VendorsPage = (VendorsPage);

;// CONCATENATED MODULE: ./pages/vendors.tsx








var Vendors = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pages_VendorsPage, (0,_object_spread/* default */.Z)({}, props));
};
Vendors.getInitialProps = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
    var index, results;
    return runtime_default().wrap(function _callee$(_ctx) {
        while(1)switch(_ctx.prev = _ctx.next){
            case 0:
                index = algoliaClient/* default.initIndex */.Z.initIndex((0,getIndexName/* default */.Z)("companies"));
                _ctx.next = 3;
                return index.search({
                    hitsPerPage: 15
                });
            case 3:
                results = _ctx.sent;
                return _ctx.abrupt("return", {
                    initialResults: results
                });
            case 5:
            case "end":
                return _ctx.stop();
        }
    }, _callee);
}));
/* harmony default export */ var vendors = (Vendors);


/***/ }),

/***/ 72851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HomepageNavigation; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(18316);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94614);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82789);
/* harmony import */ var _govlaunch_web__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19026);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54892);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22051);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59496);
/* harmony import */ var _components_auth_Auth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27068);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69057);










function HomepageNavigation() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var tabsRef = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.createRef)();
    var viewer = (0,_components_auth_Auth__WEBPACK_IMPORTED_MODULE_4__/* .useSelfie */ .yD)();
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    var pathname = router === null || router === void 0 ? void 0 : router.pathname;
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        if (!tabsRef.current) {
            return;
        }
        if (pathname === "/vendors") {
            tabsRef.current.scrollLeft = 200;
        }
    }, []);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu, {
                overflow: "hidden",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu, {
                    display: [
                        "flex",
                        "flex",
                        "none"
                    ],
                    overflowX: [
                        "scroll",
                        "scroll",
                        "auto"
                    ],
                    ref: tabsRef,
                    alignItems: "center",
                    justifyContent: "space-between",
                    bg: "white",
                    mb: 2,
                    px: 2,
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/collections",
                            passHref: true,
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(MobileNavigationItem, {
                                icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("svg", {
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    css: {
                                        marginLeft: 4
                                    },
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                                        fillRule: "evenodd",
                                        clipRule: "evenodd",
                                        d: "M2.30769 0C1.67521 0 1.07368 0.2244 0.649038 0.649038C0.2244 1.07368 0 1.67521 0 2.30769V5.38462V8.46154V17.6923C0 18.3248 0.2244 18.9263 0.649038 19.351C1.07368 19.7756 1.67521 20 2.30769 20H5H17.6923H18C19.1046 20 20 19.1046 20 18V17.6923V9.23077V8.46154V8V6.92308V5.38462C20 4.75214 19.7756 4.1506 19.351 3.72596C18.9263 3.30132 18.3248 3.07692 17.6923 3.07692H9.23077V2.30769C9.23077 1.67521 9.00637 1.07368 8.58173 0.649038C8.15709 0.2244 7.55556 0 6.92308 0H2.30769ZM18 6C18.1589 6 18.3134 6.01852 18.4615 6.05352V5.38462C18.4615 5.09402 18.377 4.92752 18.2632 4.8137C18.1494 4.69988 17.9829 4.61538 17.6923 4.61538H9.23077C8.82906 4.61538 8.41803 4.46971 8.12801 4.17969C7.83798 3.88966 7.69231 3.47863 7.69231 3.07692V2.30769C7.69231 2.01709 7.60781 1.8506 7.49399 1.73678C7.38017 1.62296 7.21368 1.53846 6.92308 1.53846H2.30769C2.01709 1.53846 1.8506 1.62296 1.73678 1.73678C1.62296 1.8506 1.53846 2.01709 1.53846 2.30769V5.38462V8.46154V17.6923C1.53846 17.9829 1.62296 18.1494 1.73678 18.2632C1.8506 18.377 2.01709 18.4615 2.30769 18.4615C2.59829 18.4615 2.76478 18.377 2.87861 18.2632C2.92616 18.2157 2.9686 18.1589 3.00189 18.0878C3.00064 18.0587 3 18.0294 3 18V8C3 6.89543 3.89543 6 5 6H18ZM12.9548 11.4977L11.5 9L10.0452 11.4977L7.22025 12.1094L9.14614 14.2648L8.85497 17.1406L11.5 15.975L14.145 17.1406L13.8539 14.2648L15.7798 12.1094L12.9548 11.4977Z",
                                        fill: "currentColor"
                                    })
                                }),
                                label: intl.formatMessage({
                                    defaultMessage: "Collections",
                                    id: "ulh3kf"
                                }),
                                active: pathname === "/" || pathname === "/collections"
                            })
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/governments",
                            passHref: true,
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(MobileNavigationItem, {
                                icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("svg", {
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                                        d: "M20.7778 19.0006H19.5556V10.445H20.7778C21.3046 10.445 21.7702 10.1089 21.9364 9.60902C22.1039 9.11035 21.9316 8.56035 21.5099 8.24502L11.7321 0.911682C11.2982 0.584127 10.7006 0.584127 10.2667 0.911682L0.488889 8.24502C0.0684444 8.56035 -0.103889 9.11035 0.0635556 9.60902C0.229778 10.1089 0.695444 10.445 1.22222 10.445H2.44444V19.0006H1.22222C0.546333 19.0006 0 19.5469 0 20.2228C0 20.8987 0.546333 21.445 1.22222 21.445H20.7778C21.4537 21.445 22 20.8987 22 20.2228C22 19.5469 21.4537 19.0006 20.7778 19.0006ZM11 3.41724L17.1111 8.00057H4.88889L11 3.41724ZM4.88889 19.0006V10.445H7.33333V19.0006H4.88889ZM9.77778 19.0006V10.445H12.2222V19.0006H9.77778ZM14.6667 19.0006V10.445H17.1111V19.0006H14.6667Z",
                                        fill: "currentColor"
                                    })
                                }),
                                label: intl.formatMessage({
                                    defaultMessage: "Governments",
                                    id: "qnQX9U"
                                }),
                                active: pathname === "/governments"
                            })
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/vendors",
                            passHref: true,
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(MobileNavigationItem, {
                                icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("svg", {
                                    width: "24",
                                    height: "24",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                                        d: "M12 2C6.47714 2 2 6.47714 2 12C2 17.5229 6.47714 22 12 22C17.5229 22 22 17.5229 22 12C22 6.47714 17.5229 2 12 2ZM12.9127 17.88V19.8175H11.0476V18.0138C9.7381 17.9565 8.51409 17.6123 7.78746 17.1916L8.35639 14.9543C9.15952 15.3942 10.2854 15.7957 11.5283 15.7957C12.6183 15.7957 13.3629 15.375 13.3629 14.6102C13.3629 13.8835 12.7504 13.4246 11.3353 12.9465C9.28925 12.2581 7.89436 11.3021 7.89436 9.44722C7.89436 7.76448 9.06349 6.44508 11.127 6.04353V4.22222H12.9921V5.90968C14.2619 5.96706 15.1368 6.23476 15.7679 6.54071L15.2149 8.70151C14.7177 8.49115 13.8389 8.05135 12.4621 8.05135C11.2192 8.05135 10.818 8.58679 10.818 9.12218C10.818 9.75321 11.4875 10.1548 13.1128 10.7667C15.3883 11.5698 16.3113 12.6215 16.3113 14.3424C16.3113 16.0443 15.0952 17.4976 12.9127 17.88Z",
                                        fill: "currentColor"
                                    })
                                }),
                                label: intl.formatMessage({
                                    id: "RilevA",
                                    defaultMessage: "Vendors"
                                }),
                                active: pathname === "/vendors"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .PageGridContainer */ .pf, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu, {
                    display: [
                        "none",
                        "none",
                        "flex"
                    ],
                    justifyContent: "flex-start",
                    alignItems: "center",
                    mb: 8,
                    width: "100%",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(NavigationItem, {
                            icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("svg", {
                                width: "24",
                                height: "24",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                                    fillRule: "evenodd",
                                    clipRule: "evenodd",
                                    d: "M2.30769 0C1.67521 0 1.07368 0.2244 0.649038 0.649038C0.2244 1.07368 0 1.67521 0 2.30769V5.38462V8.46154V17.6923C0 18.3248 0.2244 18.9263 0.649038 19.351C1.07368 19.7756 1.67521 20 2.30769 20H5H17.6923H18C19.1046 20 20 19.1046 20 18V17.6923V9.23077V8.46154V8V6.92308V5.38462C20 4.75214 19.7756 4.1506 19.351 3.72596C18.9263 3.30132 18.3248 3.07692 17.6923 3.07692H9.23077V2.30769C9.23077 1.67521 9.00637 1.07368 8.58173 0.649038C8.15709 0.2244 7.55556 0 6.92308 0H2.30769ZM18 6C18.1589 6 18.3134 6.01852 18.4615 6.05352V5.38462C18.4615 5.09402 18.377 4.92752 18.2632 4.8137C18.1494 4.69988 17.9829 4.61538 17.6923 4.61538H9.23077C8.82906 4.61538 8.41803 4.46971 8.12801 4.17969C7.83798 3.88966 7.69231 3.47863 7.69231 3.07692V2.30769C7.69231 2.01709 7.60781 1.8506 7.49399 1.73678C7.38017 1.62296 7.21368 1.53846 6.92308 1.53846H2.30769C2.01709 1.53846 1.8506 1.62296 1.73678 1.73678C1.62296 1.8506 1.53846 2.01709 1.53846 2.30769V5.38462V8.46154V17.6923C1.53846 17.9829 1.62296 18.1494 1.73678 18.2632C1.8506 18.377 2.01709 18.4615 2.30769 18.4615C2.59829 18.4615 2.76478 18.377 2.87861 18.2632C2.92616 18.2157 2.9686 18.1589 3.00189 18.0878C3.00064 18.0587 3 18.0294 3 18V8C3 6.89543 3.89543 6 5 6H18ZM12.9548 11.4977L11.5 9L10.0452 11.4977L7.22025 12.1094L9.14614 14.2648L8.85497 17.1406L11.5 15.975L14.145 17.1406L13.8539 14.2648L15.7798 12.1094L12.9548 11.4977Z",
                                    fill: "currentColor"
                                })
                            }),
                            label: intl.formatMessage({
                                defaultMessage: "Collections",
                                id: "ulh3kf"
                            }),
                            href: viewer ? "/" : "/collections",
                            active: pathname === "/" || pathname === "/collections"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(NavigationItem, {
                            icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("svg", {
                                width: "24",
                                height: "24",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                                    d: "M20.7778 19.0006H19.5556V10.445H20.7778C21.3046 10.445 21.7702 10.1089 21.9364 9.60902C22.1039 9.11035 21.9316 8.56035 21.5099 8.24502L11.7321 0.911682C11.2982 0.584127 10.7006 0.584127 10.2667 0.911682L0.488889 8.24502C0.0684444 8.56035 -0.103889 9.11035 0.0635556 9.60902C0.229778 10.1089 0.695444 10.445 1.22222 10.445H2.44444V19.0006H1.22222C0.546333 19.0006 0 19.5469 0 20.2228C0 20.8987 0.546333 21.445 1.22222 21.445H20.7778C21.4537 21.445 22 20.8987 22 20.2228C22 19.5469 21.4537 19.0006 20.7778 19.0006ZM11 3.41724L17.1111 8.00057H4.88889L11 3.41724ZM4.88889 19.0006V10.445H7.33333V19.0006H4.88889ZM9.77778 19.0006V10.445H12.2222V19.0006H9.77778ZM14.6667 19.0006V10.445H17.1111V19.0006H14.6667Z",
                                    fill: "currentColor"
                                })
                            }),
                            label: intl.formatMessage({
                                defaultMessage: "Governments",
                                id: "qnQX9U"
                            }),
                            href: "/governments",
                            active: pathname === "/governments"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(NavigationItem, {
                            icon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("svg", {
                                width: "24",
                                height: "24",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("path", {
                                    d: "M12 2C6.47714 2 2 6.47714 2 12C2 17.5229 6.47714 22 12 22C17.5229 22 22 17.5229 22 12C22 6.47714 17.5229 2 12 2ZM12.9127 17.88V19.8175H11.0476V18.0138C9.7381 17.9565 8.51409 17.6123 7.78746 17.1916L8.35639 14.9543C9.15952 15.3942 10.2854 15.7957 11.5283 15.7957C12.6183 15.7957 13.3629 15.375 13.3629 14.6102C13.3629 13.8835 12.7504 13.4246 11.3353 12.9465C9.28925 12.2581 7.89436 11.3021 7.89436 9.44722C7.89436 7.76448 9.06349 6.44508 11.127 6.04353V4.22222H12.9921V5.90968C14.2619 5.96706 15.1368 6.23476 15.7679 6.54071L15.2149 8.70151C14.7177 8.49115 13.8389 8.05135 12.4621 8.05135C11.2192 8.05135 10.818 8.58679 10.818 9.12218C10.818 9.75321 11.4875 10.1548 13.1128 10.7667C15.3883 11.5698 16.3113 12.6215 16.3113 14.3424C16.3113 16.0443 15.0952 17.4976 12.9127 17.88Z",
                                    fill: "currentColor"
                                })
                            }),
                            label: intl.formatMessage({
                                id: "RilevA",
                                defaultMessage: "Vendors"
                            }),
                            href: "/vendors",
                            active: pathname === "/vendors"
                        })
                    ]
                })
            })
        ]
    });
};
function NavigationItem(param) {
    var icon = param.icon, label = param.label, href = param.href, active = param.active;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu, {
            as: "a",
            display: "flex",
            alignItems: "center",
            mr: 6,
            color: active ? "blue.600" : "gray.800",
            mt: [
                4,
                4,
                0
            ],
            children: [
                icon,
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Text */ .xv, {
                    fontSize: "md",
                    fontWeight: "semibold",
                    ml: 2,
                    as: active ? "h1" : "p",
                    children: label
                })
            ]
        })
    });
}
var MobileNavigationItem = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_3__.forwardRef)(function(_param, ref) {
    var icon = _param.icon, label = _param.label, active = _param.active, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "icon",
        "label",
        "active"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        as: "a",
        color: active ? "blue.600" : "gray.800",
        display: "flex",
        flexDirection: [
            "column",
            "column",
            "row"
        ],
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        minHeight: "72px",
        borderTop: "1px",
        borderTopWidth: "5px",
        py: 2,
        px: [
            "8px",
            "8px",
            "24px"
        ],
        borderColor: active ? "blue.600" : "transparent",
        ref: ref,
        _hover: {
            bg: "blue.50"
        }
    }, props), {
        children: [
            icon,
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Text */ .xv, {
                fontWeight: "semibold",
                fontSize: [
                    "md",
                    "md",
                    "lg"
                ],
                whiteSpace: "nowrap",
                mt: 1,
                children: label
            })
        ]
    }));
});
MobileNavigationItem.displayName = "MobileNavigationItem";


/***/ }),

/***/ 38594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useDebounce; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
;// CONCATENATED MODULE: ./node_modules/.pnpm/react-use@17.4.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-use/esm/useTimeoutFn.js

function useTimeoutFn(fn, ms) {
    if (ms === void 0) { ms = 0; }
    var ready = (0,react.useRef)(false);
    var timeout = (0,react.useRef)();
    var callback = (0,react.useRef)(fn);
    var isReady = (0,react.useCallback)(function () { return ready.current; }, []);
    var set = (0,react.useCallback)(function () {
        ready.current = false;
        timeout.current && clearTimeout(timeout.current);
        timeout.current = setTimeout(function () {
            ready.current = true;
            callback.current();
        }, ms);
    }, [ms]);
    var clear = (0,react.useCallback)(function () {
        ready.current = null;
        timeout.current && clearTimeout(timeout.current);
    }, []);
    // update ref when function changes
    (0,react.useEffect)(function () {
        callback.current = fn;
    }, [fn]);
    // set on mount, clear on unmount
    (0,react.useEffect)(function () {
        set();
        return clear;
    }, [ms]);
    return [isReady, clear, set];
}

;// CONCATENATED MODULE: ./node_modules/.pnpm/react-use@17.4.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-use/esm/useDebounce.js


function useDebounce(fn, ms, deps) {
    if (ms === void 0) { ms = 0; }
    if (deps === void 0) { deps = []; }
    var _a = useTimeoutFn(fn, ms), isReady = _a[0], cancel = _a[1], reset = _a[2];
    (0,react.useEffect)(reset, deps);
    return [isReady, cancel];
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3481,5522,9932,9774,2888,179], function() { return __webpack_exec__(58115); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);